var React = require('react');

function DE (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M0 2C0 0.89543 0.895431 0 2 0H16C17.1046 0 18 0.89543 18 2V4.66667H0V2Z","fill":"black","key":0}),React.createElement("rect",{"y":"4.66675","width":"18","height":"4.66667","fill":"#DD0000","key":1}),React.createElement("path",{"d":"M0 9.33325H18V11.9999C18 13.1045 17.1046 13.9999 16 13.9999H2C0.89543 13.9999 0 13.1045 0 11.9999V9.33325Z","fill":"#FFCE00","key":2})]);
}

DE.defaultProps = {"width":"18","height":"14","viewBox":"0 0 18 14","fill":"none"};

module.exports = DE;

DE.default = DE;
